import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import WhatIsMyHomeWorthPage from "@/pages/tools/WhatIsMyHomeWorth";

export const Route = createFileRoute("/tools/what-is-my-home-worth")({
  head: () => seoHead("/tools/what-is-my-home-worth"),
  component: WhatIsMyHomeWorthPage,
});